// #region Imports

import * as $ from 'jquery';
import { NotePackageService } from '../services/notePackageService';

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindButton();
}

// #endregion Exports

// #region Private functions

function bindButton(): void {
    $('.js-import-action-button').bind('click', importNotes);
}

function unbindButton(): void {
    $('.js-import-action-button').unbind('click', importNotes);
}

function importNotes(event): void {
    event.preventDefault();

    blockModal();

    const service = new NotePackageService();
    service.importNotes((window as any)._share, (window as any)._key, onSuccess, onFailure);
}

function onSuccess(): void {
    $('.modal-notes-content').hide();
    $('.modal-notes-content-success').show();

    unblockModal();
    unbindButton();
}

function onFailure(): void {
    $('.modal-notes-content').hide();
    $('.modal-notes-content-failed').show();

    unblockModal();
}

function blockModal(): void {
    $('.modal__window').addClass('modal__window--busy');
}

function unblockModal(): void {
    $('.modal__window').removeClass('modal__window--busy');
}

// #endregion Private functions